export const USERS_NAMESPACE: string = 'users'
export const USER_EMAIL_FIELD_NAME: string = 'email'
export const USER_TYPE_FIELD_NAME: string = 'userType'
export const USER_CRM_LICENCE_FIELD_NAME: string = 'crmLicence'
export const USE_EMAIL_AS_USERNAME_FIELD_NAME: string = 'useEmailAsUsername'

export const getUserEmailFieldName = (index: number): string => `${USERS_NAMESPACE}[${index}].${USER_EMAIL_FIELD_NAME}`
export const getUserTypeFieldName = (index: number): string => `${USERS_NAMESPACE}[${index}].${USER_TYPE_FIELD_NAME}`
export const getCrmLicenceFieldName = (index: number): string =>
    `${USERS_NAMESPACE}[${index}].${USER_CRM_LICENCE_FIELD_NAME}`
export const getUseEmailAsUsernameFieldName = (index: number): string =>
    `${USERS_NAMESPACE}[${index}].${USE_EMAIL_AS_USERNAME_FIELD_NAME}`
